module.exports = __webpack_public_path__ + "1791188489487/images/maestrocard.796fb62.png";